/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bound } from './bound';

/**
 * 旅程情報
 */
export interface GetOrderResponseDataAir {
  /**
   * 第一便の搭乗日がDCS移行開始日以降
   */
  isAfterDcsMigrationTrip?: boolean;
  /**
   * 旅程区分<br/> domestic：日本国内単独旅程<br/> international：国際旅程
   */
  tripType?: GetOrderResponseDataAir.TripTypeEnum;
  /**
   * DISRUPTION有無<br/> セグメントステータスがUNであるセグメントが存在する場合にtrue
   */
  isContainedCancelledFlight?: boolean;
  /**
   * 欠航となったNHグループ便名NHグループ運航の有無<br/> セグメントステータスがUNであるNHグループ便名NHグループ運航の便が存在する場合にtrue
   */
  isContainedCancelledNhFlight?: boolean;
  /**
   * 一部搭乗済みであるか<br/> クーポンステータスが使用済みであるｅチケットが存在する場合にtrue
   */
  isPartiallyBoarded?: boolean;
  /**
   * NHグループ便名セグメント有無<br/> NHグループ便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupMarketingSegment?: boolean;
  /**
   * NHグループ運航セグメント有無<br/> NHグループ運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupOperatingSegment?: boolean;
  /**
   * 他社便名セグメント有無<br/> 他社便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierMarketingSegment?: boolean;
  /**
   * 他社運航セグメント有無<br/> 他社運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierOperatingSegment?: boolean;
  /**
   * 空席待ちセグメント有無<br/> セグメントステータスが空席待ち(設定ファイルに定義)であるセグメントが存在する場合にtrue
   */
  isContainedWaitlistedSegment?: boolean;
  /**
   * スケジュールチェンジセグメント有無<br/> スケジュールチェンジが発生しているかがtrueであるセグメントが存在する場合にtrue
   */
  isContainedScheduleChangedFlight?: boolean;
  /**
   * 最上位キャビンクラス<br/> 国際旅程で日本発着国際線がある場合は、そのセグメントのうち最上位のキャビンクラス、そうでない場合は全セグメントのキャビンクラスの内、最上位のものを返却する<br/> eco：エコノミー<br/> ecoPremium：プレミアムエコノミー<br/> business：ビジネス<br/> first：ファースト
   */
  highestCabinClass?: GetOrderResponseDataAir.HighestCabinClassEnum;
  /**
   * バウンドリスト<br/> ※以下のいずれかの条件に該当するセグメントは返却しない<br/> 1.ステータスがパッシブセグメント(対象となるステータスは設定ファイルに定義)<br/> 2.ステータスがゴーストセグメント(対象となるステータスは設定ファイルに定義)<br/> 3.キャリアコード未指定(キャリアコード＝YYとしてDxAPIから返却)のOPEN便<br/> 4.Informative Segment<br/> 5.フリーテキストに\"\"WEB//@IGNORE\"\"を含むRMエレメントがリレートしているセグメント<br/> ※アップグレード空席待ちの上位セグメントは、下位セグメントにマージして返却する<br/> ※メジャースケジュールチェンジが発生しているバウンドが存在する場合、そのバウンドのoriginalFlights(振替前セグメント情報リスト)の内、セグメントステータスがUNのセグメントのみで構成されるバウンド情報を作成し、当該バウンドの直前に挿入して返却する。
   */
  bounds?: Array<Bound>;
  /**
   * ルフトハンザサイトで座席指定可能なセグメント有無<br/> 以下の条件を満たす場合、trueを返却する<br/> 1 IATAエリアを跨いでいる<br/> 2 LH運航である<br/> 3 キャビンクラスが、設定ファイルに定義したルフトハンザ便のdeeplink対象キャビンクラスである
   */
  isContainedSeatRequestableSegmentInLHSite?: boolean;
  /**
   * 香港発着セグメントを含むか<br/> 出発地または到着地が香港であるセグメントが旅程に含まれる場合にtrue
   */
  isContainedHongKongSegment?: boolean;
  /**
   * 日本国内線のセグメントが含まれるか<br/> 日本国内線のセグメントが含まれる場合true
   */
  isContainedJapanDomesticSegment?: boolean;
  /**
   * Dynamic Waiver Refund対象便有無<br/> Dynamic Waiver Refund対象便が含まれる場合true<br/> ※DxAPIでDynamic Waiver Change対象便の場合（FY23の時点）
   */
  isContainedDynamicWaiverFlight?: boolean;

  isContainedShareholdersBenefitDiscountFare?: boolean;
  isContainedBusniessKippuFares?: boolean;
  isContainedShareholdersBenefitDiscountFareByPostCollection?: boolean;
}
export namespace GetOrderResponseDataAir {
  export type TripTypeEnum = 'domestic' | 'international';
  export const TripTypeEnum = {
    Domestic: 'domestic' as TripTypeEnum,
    International: 'international' as TripTypeEnum,
  };
  export type HighestCabinClassEnum = 'eco' | 'ecoPremium' | 'business' | 'first';
  export const HighestCabinClassEnum = {
    Eco: 'eco' as HighestCabinClassEnum,
    EcoPremium: 'ecoPremium' as HighestCabinClassEnum,
    Business: 'business' as HighestCabinClassEnum,
    First: 'first' as HighestCabinClassEnum,
  };
}
